'use client';

import Image from '@eliadmin/core/src/components/image/image-wrapped';
import Link from '@eliadmin/core/src/components/link';

import type { ProductDetailData } from '@eliadmin/core/src/api/products/types/product-types';

import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { Heading } from '../../../ui/heading';
import { Button } from '../../../ui/button';

function getFileExtension(value?: string): string {
  if (!value) return 'FILE';

  try {
    const pathname = value.startsWith('http') ? new URL(value).pathname : value;

    const ext = pathname.split('.').pop();
    return ext ? ext.toUpperCase() : 'FILE';
  } catch {
    return 'FILE';
  }
}

export function ProductTabsDocuments({ product }: { product: ProductDetailData }) {
  const { t } = useTranslations();

  return (
    <div className="flex w-full flex-col items-start justify-start gap-8">
      <Heading title={t('text2406')} />
      <div className="grid-cols-sm grid w-full gap-4 sm:grid-cols-2 md:grid-cols-3 md:gap-5 lg:grid-cols-4 xl:gap-6">
        {product.attachments &&
          product.attachments.length > 0 &&
          product.attachments.map(attachment => {
            const fileType = getFileExtension(attachment.url || attachment.name);

            return (
              <div
                key={attachment.name}
                className="col-span-1 flex w-full flex-col items-center justify-center gap-4 rounded-[4px] border border-border p-4 md:gap-[18px] md:p-[18px]"
              >
                <Image
                  src={'/images/icons/pdf-icon.svg'}
                  alt={attachment.name}
                  width={0}
                  height={0}
                  className="h-16 w-auto object-contain"
                />
                <div className="flex w-full flex-col items-center justify-center text-center">
                  <Heading
                    tag="h6"
                    title={attachment.name}
                    className={{ title: 'line-clamp-1 text-center' }}
                  />
                  <p className="text-xs text-muted">{fileType} (2MB - BACKEND TODO)</p>
                </div>
                <Button className="w-full" variant={'dark'} asChild>
                  <Link
                    prefetch={false}
                    href={attachment.url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {t('text717')}
                  </Link>
                </Button>
              </div>
            );
          })}
      </div>
    </div>
  );
}
